import { WhatsAppPhoneState } from '@/types';

export const WhatsAppPhoneStateColorMap = {
    [WhatsAppPhoneState.OPERATING]: { variant: 'green-100', textVariant: 'green-800' },
    [WhatsAppPhoneState.NOT_ENABLED]: { variant: 'yellow-100', textVariant: 'yellow-800' },
    [WhatsAppPhoneState.AWAITING_META]: { variant: 'yellow-100', textVariant: 'yellow-800' },
    [WhatsAppPhoneState.INACTIVE]: { variant: 'gray-100', textVariant: 'gray-700' },
    [WhatsAppPhoneState.UNKNOWN]: { variant: 'gray-100', textVariant: 'gray-700' },
};
